var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAllLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 2.66675H4.00033C3.6467 2.66675 3.30756 2.80722 3.05752 3.05727C2.80747 3.30732 2.66699 3.64646 2.66699 4.00008V12.0001C2.66699 12.3537 2.80747 12.6928 3.05752 12.9429C3.30756 13.1929 3.6467 13.3334 4.00033 13.3334H12.0003C12.3539 13.3334 12.6931 13.1929 12.9431 12.9429C13.1932 12.6928 13.3337 12.3537 13.3337 12.0001V9.33341M8.00033 8.00008L13.3337 2.66675M13.3337 2.66675V6.00008M13.3337 2.66675H10.0003",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllLight);
export default __webpack_public_path__ + "static/media/view-all-light.371afb909ac73e23dced2584700d0e35.svg";
export { ForwardRef as ReactComponent };